import CheckIcon from "@mui/icons-material/Check";
import {
  Card,
  CardActions,
  CardContent,
  Grow,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLoginModalContext } from "../../../../context/LoginModalContext";
import { useLoginStatus } from "../../../../context/LoginStatusContext";
import { useCustomNavigate } from "../../../../hooks/useCustomNavigate";
import { ColumnCenteredBox } from "../../../../utils/styledBox";
import { GradientTypography } from "../../../../utils/gradientTypography";
import { GradationButton } from "../../../../utils/gradationButton";
import { alpha } from "@mui/material/styles";

const EnterprisePlanCard = () => {
  const { t } = useTranslation();
  const { isLoggedIn } = useLoginStatus();
  const loginModalContext = useLoginModalContext();
  const navigate = useCustomNavigate();

  const handleContactClick = () => {
    if (isLoggedIn) {
      // 遷移先をフィードバックに基づき変更
      navigate("/preferences/misc?supportForm=open");
    } else {
      // ログインモーダルを表示し、ログイン後のリダイレクト先を現在のページに設定
      loginModalContext.setRequestPathToCookie(window.location.pathname + window.location.search);
      loginModalContext.setActiveModal("login");
    }
  };

  // 特徴リストをフィードバックに基づき更新 (i18nキーも後で修正)
  const features = [
    t("pricing.enterprise.feature1"), // 無期限かつ割安クレジット
    t("pricing.enterprise.feature2"), // 共有
    t("pricing.enterprise.feature3"), // 専用サポート
    t("pricing.enterprise.feature4"), // 組織の設定ができる
  ];

  return (
    <Grow in={true} timeout={1000}>
      <Card
        sx={{
          width: { xs: "90%", sm: 600 },

          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          borderRadius: 2,
          color: "white",
          p: 2,
          mx: "auto",
          backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.8),
          backdropFilter: "blur(10px)",
        }}
      >
        <CardContent>
          <ColumnCenteredBox sx={{ gap: 2 }}>
            <GradientTypography variant="h4" component="div" gutterBottom sx={{ fontWeight: "bold" }}>
              {t("pricing.enterprise.title")}
            </GradientTypography>
            <div>
              <Typography color="text.secondary">{t("pricing.enterprise.description")}</Typography>
              <Typography color="text.secondary" sx={{ mb: 1 }}>
                {t("pricing.enterprise.description2")}
              </Typography>
              <Typography variant={"caption"} color="text.secondary">
                60,000 Credits ~
              </Typography>
            </div>

            {/* 料金表示を削除 */}
            <List dense sx={{ my: 2 }}>
              {/* マージン調整 */}
              {features.map((feature, index) => (
                <ListItem key={index} disablePadding>
                  <ListItemIcon sx={{ minWidth: "auto", mr: 1 }}>
                    <CheckIcon fontSize="small" color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={feature} />
                </ListItem>
              ))}
            </List>
            <Typography variant="body2" sx={{ textAlign: "center" }} color="text.secondary">
              {t("pricing.enterprise.contactDetail")}
            </Typography>
          </ColumnCenteredBox>
        </CardContent>
        <CardActions sx={{ justifyContent: "center", p: 2 }}>
          <GradationButton size="large" onClick={handleContactClick} sx={{ width: "80%" }}>
            {t("pricing.enterprise.contact")}
          </GradationButton>
        </CardActions>
      </Card>
    </Grow>
  );
};

export default EnterprisePlanCard;
